import { DialogFullScreenComponentContent } from './../../../models/dialogs/dialog-full-screen';
import { Component, ElementRef, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    templateUrl: './overlay-simple.component.html',
})

export class OverlaySimpleComponent extends DialogFullScreenComponentContent {
    constructor(
        public dialogReference: MatDialogRef<OverlaySimpleComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public element: ElementRef,
    ) {
        super(element, '.overlay-graphic');
    }

    public dispose() {
        $('html, body')
            .css('overflow', 'visible');
        super.close(this.dialogReference, null);
    }
}
